import { module as m } from 'modujs';
import gsap from 'gsap';

export default class extends m {
    constructor(m) {
        super(m);

        // DOM
        this.dom = {};
        this.dom.open = document.querySelector('#header-mobile .button-open');

        // VAR
        this.isOpen = false;
        this.currentSubmenu = null;

        // FUNC
        this.open = this.open.bind(this);

        // EVENTS
        this.events = {
            'click': {
                'close': 'close',
                'back': 'back',
                'item': 'showCurrentSubmenu'
            }
        }
    }

    init() {
        console.log('INIT', this.dom.open);

        // OPEN
        this.dom.open.addEventListener('click', this.open);
    }

    /**
     * OPEN
     */
    open() {
        console.log('OPEN MOBILE');
        this.isOpen = true;
        const _tl = gsap.timeline();
        _tl.to(this.el, {
            duration: 0.6,
            alpha: 1,
            display: 'block',
            ease: 'power4.out'
        });
        _tl.from(this.el.querySelectorAll('.main-list__item'), {
            duration: 0.6,
            alpha: 0,
            yPercent: 20,
            stagger: 0.05,
            rotation: 0.1,
            ease: 'power4.out'
        }, 0.2);
    }

    /**
     * CLOSE
     */
    close() {
        if(this.isOpen) {
            const _tl = gsap.timeline({
                onComplete: () => {
                    this.isOpen = false;
                    if(this.currentSubmenu) {
                        gsap.set(this.currentSubmenu.querySelector('.submenu__top'), {
                            x: '100%',
                        });
                        gsap.set(this.currentSubmenu.querySelector('.submenu__bottom'), {
                            x: '100%',
                        });
                        this.currentSubmenu.scrollTop = 0;
                        this.currentSubmenu.style.display = 'none';
                        this.currentSubmenu = null;
                    }
                    this.el.style.display = 'none';
                }
            });
            _tl.to(this.el, {
                duration: 0.6,
                alpha: 0,
                ease: 'power4.out'
            });
        }
    }

    /**
     * BACK
     */
    back() {
        const _tl = gsap.timeline({
            onComplete: () => {
                this.currentSubmenu.scrollTop = 0;
                this.currentSubmenu.style.display = 'none';
                this.currentSubmenu = null;
            }
        });
        _tl.to(this.currentSubmenu.querySelector('.submenu__top'), {
            duration: 1,
            x: '100%',
            ease: 'power4.inOut'
        });
        _tl.to(this.currentSubmenu.querySelector('.submenu__bottom'), {
            duration: 1,
            x: '100%',
            ease: 'power4.inOut'
        }, 0);
    }

    /**
     * SHOW CURRENT SUBMENU
     */
    showCurrentSubmenu(e) {
        const _id = e.currentTarget.dataset.id;
        this.currentSubmenu = this.el.querySelector('.submenu.' + _id);
        this.currentSubmenu.style.display = 'block';

        const _tl = gsap.timeline();
        _tl.to(this.currentSubmenu.querySelector('.submenu__top'), {
            duration: 1,
            x: 0,
            ease: 'power4.inOut'
        });
        _tl.to(this.currentSubmenu.querySelector('.submenu__bottom'), {
            duration: 1,
            x: 0,
            ease: 'power4.inOut'
        }, 0);
    }
}
